<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          label="Identifikavimo kodas"
          tooltip="Hipoteka. Turtas. Jūrų laivas. Identifikavimo kodas"
          :readonly="turtasReadonly || !sudarymas"
          :counter="10"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Registracijos numeris"
          tooltip="Hipoteka. Turtas. Jūrų laivas. Registracijos numeris"
          :readonly="turtasReadonly"
          :counter="20"
          v-model="formData.tur_juru_laivas_registracijos_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-date-picker
          label="Pastatymo metai"
          tooltip="Hipoteka. Turtas. Jūrų laivas. Pastatymo metai"
          :readonly="turtasReadonly"
          v-model="formData.tur_juru_pastatymo_metai"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Pavadinimas"
          tooltip="Hipoteka. Turtas. Jūrų laivas. Pavadinimas"
          :readonly="turtasReadonly"
          :counter="40"
          v-model="formData.tur_juru_laivas_pavadinimas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Paskirtis"
          tooltip="Hipoteka. Turtas. Jūrų laivas. Paskirtis"
          :readonly="turtasReadonly"
          :counter="80"
          v-model="formData.tur_juru_laivas_paskirtis"
        />
      </v-col>
      <v-col cols="12" md="6"></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasJuruLaivas',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
}
</script>
